import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'
import { Field, Form } from 'redux-form'
import { asyncValidate, shouldAsyncValidate } from "redux-form-yup"
import withForm from 'with/Form'

import SelectField from 'components/SelectField'
import TextField from 'components/TextField'
import Button from 'components/buttons/Button'
import FormWithActions from 'layout/FormWithActions'
import Delete from 'components/Delete'

import { LoadingBox } from 'components/LoadingSpinner'

import EmployeesAPI from 'api/EmployeesAPI'
import DivisionsAPI from 'api/DivisionsAPI'
import handleFormErrors from 'utils/handleFormErrors'


import schema from './schema'
import styles from './index.css'

@withForm({
  asyncValidate : asyncValidate(schema),
  shouldAsyncValidate
})
export default class EmployeeForm extends React.Component {
  
  static propTypes = {
    form        : PropTypes.string.isRequired,
    submitLabel : PropTypes.string,
    onClose     : PropTypes.func,
    onSubmit    : PropTypes.func.isRequired,
  }

  static defaultProps = {
    onClose : () => {}
  }

  state = { 
    divisions: []
  }

  async fetchDivisions() {
    const {response} = await DivisionsAPI.list()
    this.setState({ divisions: response })
  }

  componentDidMount() {
    this.fetchDivisions()
  }

  constructor(props) {
    super(props)
  }

  render() {
    const { handleSubmit } = this.props
    return (
      <Form form={this.props.form} onSubmit={handleSubmit}>
        <FormWithActions title={this.props.title}
          actions={[
            <Button 
              key={0}
              type='button'
              color='grey'
              onClick={() => this.props.onClose()}
              >
              Cancel
            </Button>
            ,
            <Button 
              key={1}
              loading={this.props.submitting}
              type='submit'
              color='orange' 
              style={{margin: '2rem 0rem'}}>
              {this.props.submitLabel || 'Save'}
            </Button>
          ]}>
          <Field 
            name='name' 
            label='Name'
            type='text'
            component={TextField} 
            />
          <Field 
            name='id_code' 
            label='ID Code'
            type='text'
            component={TextField} 
            />
          <Field 
            name='division_id'
            label='Assign to division'
            component={SelectField}
            >
            <option value={null}>-</option>
            {
              this.state.divisions.map(({ id, name }) => 
                <option key={id} value={id}>{name}</option>
            )
            }
          </Field>
        </FormWithActions>
      </Form>
    )
  }
}


export class AddEmployeeForm extends React.Component {
    
  static propTypes = {
    onClose : PropTypes.func,
    onSubmitted: PropTypes.func,
  }

  static defaultProps = {
    onClose : () => {},
    onSubmitted: () => {}
  }

  constructor(props) {
    super(props)
    this.submit = this.submit.bind(this)
  }

  submit = async (values) => {
    const {response} = handleFormErrors(await EmployeesAPI.create(values))
    this.props.onSubmitted(response)
    this.props.onClose()
  }

  render() {
    return (
      <EmployeeForm 
        form={"AddEmployeeForm"}
        title={"Add User"}
        submitLabel={"Add User"}
        onClose={this.props.onClose}
        onSubmit={this.submit}
        />
    )
  }
}



export class EditEmployeeForm extends React.Component {
    
  static propTypes = {
    id : PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
    onClose : PropTypes.func,
    onSubmitted: PropTypes.func,
  }

  static defaultProps = {
    onClose : () => {},
    onSubmitted: () => {}
  }

  state = {
    initialValues : null
  }

  api2ui(response) {
    return {
      ...response,
      division_id: (response && response.division && response.division.id) || null
    }
  }
 
  async componentDidMount() {
    const res = await EmployeesAPI.get(this.props.id)
    if (res.response) {
      this.setState({ initialValues: this.api2ui(res.response) })
    }
  }

  constructor(props) {
    super(props)
    this.submit = this.submit.bind(this)
  }

  submit = async (values) => {
    const {response} = handleFormErrors(await EmployeesAPI.update(this.props.id, values))
    this.props.onSubmitted(response)
    this.props.onClose()
  }

  render() {
    const { initialValues } = this.state
    if (!initialValues) return <LoadingBox />
    return (
      <EmployeeForm 
        initialValues={initialValues}
        form={"EditEmployeeForm"}
        title={"Edit User"}
        submitLabel={"Edit User"}
        onClose={this.props.onClose}
        onSubmit={this.submit}
        />
    )
  }
}


export class DeleteEmployeeForm extends React.Component {
    
  static propTypes = {
    id : PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
    onClose : PropTypes.func,
    onSubmitted: PropTypes.func,
  }

  static defaultProps = {
    onClose : () => {},
    onSubmitted: () => {}
  }

  constructor(props) {
    super(props)
    this.submit = this.submit.bind(this)
  }

  submit = async (event) => {
    const {response} = handleFormErrors(await EmployeesAPI.delete(this.props.id))
    this.props.onSubmitted(response)
    this.props.onClose()
  }

  render() {
    return (
      <Delete 
        title={"Delete User"}
        submitLabel={"Delete User"}
        entityName={"this User"}
        onCancel={this.props.onClose}
        onConfirm={this.submit}
        />
    )
  }
}



// WEBPACK FOOTER //
// ./src/forms/Employee/index.jsx